<div id="datepicker-container">
    <span class="p-input-icon-right" >
      <i class="pi pi-times"  *ngIf="showClearButton && value" (click)="clearDateTimeControl();"></i>
      <input type="text" pInputText (click)="datepicker.open()"
      [name]="controlId"
      [matDatepicker]="datepicker"
      [max]="endDate"
      [disabled]="isDisabled ? 'disabled' : null"
      [placeholder]="placeholderText||''"
       class="form-control"
       [value]="value"
       (dateChange)="updateDate($event)"
      />
    </span>
    <mat-datepicker #datepicker></mat-datepicker>
</div>
